import React, { useState, useRef } from 'react';
//import { toast } from "react-toastify";
// import './.css';
import './Deletepost.css'
import axios from 'axios';

function DeletePost() {
  const h2Ref = useRef();
  const [id, setId] = useState("");
  const submitHandler = (e) => {
    e.preventDefault(); // Fixed typo
    axios.delete("https://jsonplaceholder.typicode.com/posts/" + id) // Fixed incorrect data format
      .then(() => {
        h2Ref.current.innerHTML = "Success"; // Fixed innerHTML issue
        //toast("success delete");
      })
      .catch(err => console.log(err));
  };

  return (
    <div className='Send'>
      <h2 ref={h2Ref}>Delete post</h2>
      <form onSubmit={submitHandler}>
        <input
          type='text'
          name='id'
          value={id}
          placeholder='Enter id'
          required // Fixed required attribute
          onChange={(e) => setId(e.target.value)}
        />

        <button type='submit'>delete</button>
      </form>
    </div>
  );
}

export default DeletePost;